<template>
  <div>
    <modal modal-id="add-pe">
      <div slot="title">Run Page Entities</div>
      <div slot="form">
        <div class="row">
          <div class="col-lg-12 m-b-sm">
            <button :class="'btn btn-sm button ' + (!showBulk ? ' btn-primary' : '')"  @click="showBulk = false">Single</button>
            <button :class="'btn btn-sm ' + (showBulk ? ' btn-primary' : '')"  @click="showBulk = true">Bulk</button>
          </div>
          <div v-if="showBulk" class="col-lg-12 m-b-sm">
            <textarea rows="4" class="form-control" placeholder="Url, keyword, grade (default 4). One per line" v-model.trim="peData['bulk']"></textarea>
          </div>
          <div v-else>
            <div class="col-lg-12 m-b-sm">
              <input type="text" class="form-control" placeholder="Url" v-model.trim="peData['url']">
            </div>
            <div class="col-lg-12 m-b-sm">
              <input type="text" class="form-control" placeholder="Keyword" v-model.trim="peData['keyword']">
            </div>
            <div class="col-lg-12 m-b-sm">
              <input type="number" class="form-control" placeholder="Grade" v-model.number="peData['grade']" min="1" max="5">
            </div>
          </div>
          <div class="col-lg-12 m-b-sm">
            <v-select :options="locations" placeholder="Country" label="location_name" index="location_name" v-model="peData['location']"></v-select>
          </div>
          <div class="col-lg-12 m-b-sm">
            <v-select :options="languages" placeholder="Language" label="language_name" index="language_name" v-model="peData['language']"></v-select>
          </div>
          <div class="col-lg-12 m-t-sm">
            <button class="btn btn-sm btn-primary pull-right" @click="runPE">Run</button>
          </div>
        </div>
      </div>
    </modal>
    <div class="row">
      <div class="col-lg-12">
        <button class="btn btn-primary btn-xs" data-toggle="modal" data-target="#add-pe"><i class="fa fa-plus"></i> Add new</button>
      </div>
      <div class="col-lg-4">
        <table class="table table-hover table-striped">
          <thead>
          <tr>
            <th>&nbsp;</th>
            <th v-tooltip="'Grade'">G</th>
            <th v-tooltip="'Referring Domains'">RD</th>
            <th v-tooltip="'Target Referring Domains'">TRD</th>
            <th v-tooltip="'Page Entity Score'">PE</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="r in results" :key="r.id">
            <td>
              <i class="fa fa-clock orange" v-if="r.status === 'added'" v-tooltip="'Running'"></i>
              <i class="fa fa-check green" v-if="r.status === 'completed'" v-tooltip="'Completed'"></i>
              <i class="fa fa-remove red" v-if="r.status === 'failed'" v-tooltip="'Failed'"></i>
              {{ r.startTime | aTime('DD.MM. HH:mm') }}
              <br>
              <a @click="fetchResult(r.id)">{{ r.payload.keyword }}</a>
              <br>
              <a @click="fetchResult(r.id)">{{ r.payload.url }}</a>
              <br>
              <small>{{ r.payload.location }} / {{ r.payload.language || '-' }}</small>
            </td>
            <td>{{ r.payload.grade }}</td>
            <td>{{ r.payload.targetRefD }}</td>
            <td>{{ r.payload.avgRefD }}</td>
            <td>
              {{ r.payload.score || '/' }}
              <a><i class="fa fa-refresh pull-right" v-tooltip="'Run it again'" @click="rerunPE(r.id)"></i></a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-8">
        <div class="tabs-container" v-if="result">
          <table class="table table-hover table-bordered" v-if="result.status !== 'completed'">
            <thead>
            <tr>
              <th>Status</th>
              <th>Sites</th>
              <th>Keywords</th>
              <th>Urls</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <i class="fa fa-remove red" v-if="result.status === 'failed'"></i>
                <i class="fa fa-clock orange" v-if="result.status === 'added'"></i>
                <i class="fa fa-check green" v-if="result.status === 'completed'"></i>
                {{ result.status }}
              </td>
              <td>
                <progress-bar :progress="result.progress.top20"></progress-bar>
              </td>
              <td>
                <progress-bar :progress="result.progress.top20keywords"></progress-bar>
              </td>
              <td>
                <progress-bar :progress="result.progress.overlapResultsReceived"></progress-bar>
              </td>
            </tr>
            <tr v-if="result.status === 'failed'">
              <td colspan="4" class="red">
                {{ result.result.join(',') }}
              </td>
            </tr>
            </tbody>
          </table>
          <table class="table table-hover table-bordered">
            <thead>
            <tr>
              <th>Url</th>
              <th>Keyword</th>
              <th>Location</th>
              <th>Language</th>
              <th>Grade</th>
              <th>Score</th>
              <th>Overlaps</th>
              <th v-tooltip="'Referring Domains'">RD</th>
              <th v-tooltip="'Target Referring Domains'">TRD</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{ result.payload.url }}</td>
              <td>{{ result.payload.keyword }}</td>
              <td>{{ result.payload.location }}</td>
              <td>{{ result.payload.language }}</td>
              <td>
                <a-edit-txt type="number" min="0" max="5" :text="result.payload.grade" @input="changeGrade"></a-edit-txt>
              </td>
              <td>{{ result.result.score }}</td>
              <td>{{ result.result.overlaps }}</td>
              <td class="center">{{ result.payload.targetRefD }}</td>
              <td class="center">{{ result.payload.avgRefD }}</td>
            </tr>
            </tbody>
          </table>
          <ul class="nav nav-tabs" role="tablist">
            <li class="active"><a class="nav-link" data-toggle="tab" href="#pe-keywords" @click="activeComponent = 'keywords'"><i class="fa fa-list"></i> Keywords</a></li>
            <li><a class="nav-link" data-toggle="tab" href="#pe-sites" @click="activeComponent = 'sites'"><i class="fas fa-trophy"></i> Top Sites</a></li>
            <li><a class="nav-link" data-toggle="tab" href="#pe-target-keywords" @click="activeComponent='targetKeywords'"><i class="fa fa-bullseye"></i> Target Keywords</a></li>
          </ul>
        </div>
        <component :is="activeComponent" :result="result" v-if="result"></component>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import Modal from '../../../../Helpers/Modal/Form'
import locations from '../../../../../../static/countries.json'
import languages from '../../../../../../static/languages.json'
import Keywords from './PageEntity/Keywords'
import Sites from './PageEntity/Sites'
import TargetKeywords from './PageEntity/TargetKeywords'
import ProgressBar from './PageEntity/ProgressBar'

export default {
  data () {
    return {
      activeComponent: 'keywords',
      results: [],
      result: null,
      peData: {},
      locations,
      languages,
      showBulk: false
    }
  },
  mounted () {
    this.loadEntities()
  },
  components: {
    modal: Modal,
    keywords: Keywords,
    sites: Sites,
    targetKeywords: TargetKeywords,
    progressBar: ProgressBar
  },
  computed: {
    ...mapGetters({
      pbn: 'getPbn'
    })
  },
  watch: {
    pbn () {
      this.loadEntities()
      this.result = null
    }
  },
  methods: {
    loadEntities () {
      axios.get(`/pbn/site/${this.pbn.punyDomain}/page-entity/list`)
        .then(r => {
          this.results = r.data.data
        })
    },
    fetchResult (id) {
      axios.get(`/pbn/site/${this.pbn.punyDomain}/page-entity/${id}?getOverlaps=1&getSites=1&getTargetKeywords=1`)
        .then(r => {
          this.result = r.data.order
        })
    },
    runPE () {
      axios.post(`/pbn/site/${this.pbn.punyDomain}/page-entity`, this.peData)
        .then(r => {
          this.$toastr.success('Page Entity report should be completed soon')
          $('#add-pe').modal('hide')
          this.peData = {}
          this.loadEntities()
        })
        .catch(e => {
          this.$toastr.error(e.response.data.error.msg, 'Something went wrong')
        })
    },
    rerunPE (id) {
      if (!confirm('Run Page Entity report again?')) {
        return
      }
      axios.post(`/pbn/site/${this.pbn.punyDomain}/page-entity/${id}/rerun`)
        .then(r => {
          this.$toastr.success('Running it again. Check back in a couple of minutes')
          this.loadEntities()
        })
        .catch(e => {})
    },
    changeGrade (grade) {
      console.log('Setting grade to ' + grade)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/PageEntity.vue